import { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { CurrencySymbol, UserType, WorkOrderStatusType } from "../../../utils/enum";
import { displayFormattedTotalTimelog, expenseSideLabel } from "../../../utils/helpers";
import useAuth from "../../../hooks/useAuth";
import EditEngineerRatesModal from "../components/EditEngineerRatesModal";
import { useSearchParams } from "react-router-dom";

const EngineerRates = ({
  payment,
  paymentType,
  status,
  authRole,
  userAllowedActions,
  mode = "view",
  hasUpdateAccess,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const fromCustomerBoard = Boolean(searchParams.get("fromCustomerBoard"));
  return (
    <BaseCard
      className={`pt-4 pb-6 ${mode == "view" && "xl:px-56 md:px-16"} px-5 rounded-lg !mb-[0px]`}
      elevation={mode === "view" ? 1 : 0}
    >
      <div className="border-bottom mb-4  pb-1">
        {authRole === UserType.CLIENT && (
          <div className="border-bottom">
            <h6 className="text-dark">Payment Terms</h6>
            <p className="mt-2 mb-4">
              Payment for this work order will be processed{" "}
              <span className="text-secondary font-medium">{payment?.paymentTerms}</span> after the
              job is completed. If there are any issues related to the work, you will be notified
              within <span className="text-secondary font-medium">Seven days</span>.
            </p>
          </div>
        )}
        <div className=" mt-4 flex items-center justify-between pb-1">
          <div className="flex items-center pb-1">
            <h6 className={"!text-primary"}>Engineer Rates</h6>

            <span className="text-xs ml-3 text-[#686868]">
              ({paymentType === "HOURLY" && "Hourly"}
              {paymentType === "HALF_DAY" && "Half Day"}
              {paymentType === "FULL_DAY" && "Full Day"}
              {paymentType === "FIXED" && "Fixed"}
              {authRole === UserType.CLIENT && paymentType === "FTH" && "First two hours"}
              {authRole === UserType.FREELANCER && paymentType === "FTH" && "Hourly"})
            </span>
            {![
              WorkOrderStatusType.CANCELLED,
              WorkOrderStatusType.PAID,
              WorkOrderStatusType.INPROGRESS,
            ].includes(status) &&
              !fromCustomerBoard &&
              authRole === UserType.CLIENT &&
              hasUpdateAccess && (
                <i
                  className="fa-light fa-pencil text-gray-900 text-base ml-3 cursor-pointer"
                  onClick={() => setIsModalOpen(true)}
                ></i>
              )}
          </div>
          <h6 className="!text-primary font-medium">
            {CurrencySymbol[payment?.currency] || ""} {payment?.totalLabourCost?.toFixed(2) || 0}
          </h6>
        </div>
      </div>

      <BaseCard className="mt-4" elevation={0}>
        {(paymentType === "HOURLY" || paymentType === "FTH") && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Hourly rate</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 font-normal">
              {CurrencySymbol[payment?.currency] || ""} {payment?.hourlyRate?.toFixed(2) || 0}
            </p>
          </div>
        )}
        {paymentType === "FIXED" && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Fixed rate</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 font-normal">
              {CurrencySymbol[payment?.currency] || ""} {payment?.fixedAmount?.toFixed(2) || 0}
            </p>
          </div>
        )}
        {paymentType === "HALF_DAY" && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Half Day rate</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 font-normal">
              {CurrencySymbol[payment?.currency] || ""} {payment?.halfDayRate?.toFixed(2) || 0}
            </p>
          </div>
        )}
        {paymentType === "FULL_DAY" && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Full Day rate</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 font-normal">
              {CurrencySymbol[payment?.currency] || ""} {payment?.fullDayRate?.toFixed(2) || 0}
            </p>
          </div>
        )}
        {(paymentType === "HOURLY" || paymentType === "FTH") && payment?.minimumHours > 0 && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Minimum Payable Hours</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 ">
              {displayFormattedTotalTimelog(payment?.minimumHours) || 0}{" "}
            </p>
          </div>
        )}

        {paymentType === "HOURLY" && payment?.minimumHours < 1 && payment?.hoursWorked > 0 && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Payable Hours</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 ">
              {displayFormattedTotalTimelog(payment?.hoursWorked) || 0}{" "}
            </p>
          </div>
        )}

        {(paymentType === "HALF_DAY" || paymentType === "FULL_DAY") && (
          <div className="flex items-center mb-2">
            <p className="mr-2">Additional Hourly rate</p>
            <div className="border-t border-dotted border-gray-500  flex-grow"></div>
            <p className="min-w-14 ml-5 font-normal">
              {CurrencySymbol[payment?.currency] || ""} {payment?.hourlyRate?.toFixed(2) || 0}
            </p>
          </div>
        )}

        {paymentType === "HOURLY" &&
          payment?.minimumHours > 0 &&
          payment?.additionalHourlyRate > 0 && (
            <div className="flex items-center mb-2">
              <p className="mr-2">Additional Hourly rate</p>
              <div className="border-t border-dotted border-gray-500  flex-grow"></div>
              <p className="min-w-14 ml-5 font-normal">
                {CurrencySymbol[payment?.currency] || ""}{" "}
                {payment?.additionalHourlyRate?.toFixed(2) || 0}
              </p>
            </div>
          )}

        {(paymentType === "HALF_DAY" || paymentType === "FULL_DAY" || paymentType === "HOURLY") &&
          payment?.additionalHours > 0 && (
            <div className="flex items-center mb-2">
              <p className="mr-2">Additional payable hours</p>
              <div className="border-t border-dotted border-gray-500  flex-grow"></div>
              <p className="min-w-14 ml-5 font-normal">
                {displayFormattedTotalTimelog(payment?.additionalHours) || 0}
              </p>
            </div>
          )}

        {(paymentType === "HOURLY" || paymentType === "HALF_DAY" || paymentType === "FULL_DAY") &&
          payment?.nonBusinessHourRate > 0 && (
            <div className="flex items-center mb-2">
              <p className="mr-2">OOH Rates</p>
              <div className="border-t border-dotted border-gray-500  flex-grow"></div>
              <p className="min-w-14 ml-5 font-normal">
                {CurrencySymbol[payment?.currency] || ""}{" "}
                {payment.nonBusinessHourRate?.toFixed(2) || 0}
              </p>
            </div>
          )}
        {(paymentType === "HOURLY" || paymentType === "HALF_DAY" || paymentType === "FULL_DAY") &&
          payment?.nonBusinessHourRate > 0 && (
            <div className="flex items-center mb-2">
              <p className="mr-2">OOH Payable Hours</p>
              <div className="border-t border-dotted border-gray-500  flex-grow"></div>
              <p className="min-w-14 ml-5 font-normal">
                {displayFormattedTotalTimelog(payment.nonBusinessHours)}
              </p>
            </div>
          )}

        {/* {paymentType === "HOURLY" && status === "WORKDONE" && (
          <div className="flex items-center mb-2 ">
            <p className="mr-2 text-primary font-medium	">
              Actual Working Hours
            </p>
            <div className="border-t border-dotted border-primary  flex-grow"></div>
            <p className="min-w-14 ml-5 text-primary font-medium">
              {status === "WORKDONE" ||
              status === "APPROVED" ||
              status === "INCOMPLETE"
                ? ` {CurrencySymbol[payment?.currency] || "" }{" "}{payment?.hoursWorked} hrs`
                : "Pending"}
            </p>
          </div>
        )} */}

        {payment?.expenses?.length > 0 && (
          <section className="mt-6">
            <div className="border-bottom mb-4 flex justify-between pb-3 mt-5">
              <h6 className="!text-secondary">Expenses</h6>
              <h6 className="text-primary font-medium">
                {CurrencySymbol[payment?.currency] || ""} {payment?.totalExpenseCost?.toFixed(2)}
              </h6>
            </div>
            {payment?.expenses.map((expense) => (
              <Expense
                key={expense?.id}
                expenseType={expense?.expenseType}
                description={expense?.description}
                amount={expense?.amount}
                addedBy={expense?.addedBy?.role.role}
                isApproved={expense?.isApproved}
                currency={payment?.currency}
                attachment={expense?.attachment}
              />
            ))}
          </section>
        )}
      </BaseCard>
      <div
        className={`flex items-center mt-6 justify-between ${
          status === "CANCELLED" ? "bg-[#F44336]" : "bg-primary"
        } px-3 py-2 rounded-md`}
      >
        <h6 className="font-normal !text-white">
          {status === "WORKDONE"
            ? mode === "view"
              ? "Estimated Payable"
              : "Total Payable"
            : status === "APPROVED"
              ? "Total Payable"
              : status === "PAID" ||
                  (status === "CANCELLED" && userAllowedActions?.isWorkOrderCancelByClient)
                ? "Grand Total"
                : "Estimated Payment"}
        </h6>

        <h6 className="font-normal !text-white">
          {`${payment?.currency || ""}  `}{" "}
          {status === "WORKDONE" || status === "APPROVED"
            ? payment?.grandTotal?.toFixed(2) || 0
            : status === "CANCELLED" && userAllowedActions?.isWorkOrderCancelByEngineer
              ? 0
              : payment?.totalWorkOrderCost?.toFixed(2) || 0}
        </h6>
      </div>

      {mode === "view" && (
        <div className="mt-2 justify-between  py-1 rounded-md">
          <p className={status === "CANCELLED" ? "text-[#F44336]" : "text-primary"}>
            {status === "CANCELLED"
              ? userAllowedActions?.isWorkOrderCancelByClient
                ? `The above calculation is estimated cost of the work order. The actual cost will be calculated based on actual working time to complete this job.`
                : "No payment will be processed as this work order has been cancelled by Service Provider."
              : status === "WORKDONE"
                ? "This calculation reflects the estimated payable amount based on your time log, pending client confirmation."
                : status === "APPROVED"
                  ? "The final payment has been calculated based on the completed work, verified time log and approved by client."
                  : "This is the estimated payable amount; however, the final payment will be determined upon job completion based on the actual time worked."}
          </p>
        </div>
      )}
      {isModalOpen && (
        <EditEngineerRatesModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          paymentData={{
            ...payment,
            paymentType,
          }}
        />
      )}
      {/* <ServiceFee payment={payment} status={status} /> */}
    </BaseCard>
  );
};

export default EngineerRates;

function Expense({ expenseType, description, amount, addedBy, isApproved, currency, attachment }) {
  const { authRole } = useAuth();
  return (
    <div className="flex items-center mt-4 justify-between">
      <p className="font-normal mr-2 normal-case">
        {attachment?.url && (
          <a
            href={attachment.url}
            download={attachment.fileName}
            target="_blank"
            rel="noopener noreferrer"
            title={attachment.fileName}
            className="hover:underline mr-1"
          >
            <i className="fa-solid fa-paperclip" style={{ color: "#0F40AE" }}></i>
          </a>
        )}
        <span className="">
          {expenseType === "TOOLS"
            ? "Tools"
            : expenseType === "MATERIAL"
              ? "Material"
              : expenseType === "TRAVEL"
                ? "Travel"
                : expenseType === "ALL"
                  ? "All"
                  : ""}
        </span>{" "}
        Expense{description?.trim() ? ` (${description})` : ""}
      </p>
      <div className="border-t border-dotted border-gray-500 flex-grow"></div>
      <div className="bg-[#F6F6F6] inline-flex items-center  ml-2 px-2 py-1 rounded-md whitespace-nowrap">
        <i className={`fa-solid ${isApproved ? "fa-check" : "fa-xmark"}  mr-2`}></i>
        <p className="font-normal">
          {expenseSideLabel(addedBy, authRole)}:{" "}
          {CurrencySymbol[currency] || ""} {amount}
        </p>
      </div>
    </div>
  );
}
